import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { select, Store } from '@ngrx/store';

import { Observable } from 'rxjs';

import * as fromLayoutSelectors from '../../../store/selectors/layout.selectors';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'red-header-content',
  standalone: false,
  styleUrls: ['./header-content.component.scss'],
  templateUrl: './header-content.component.html'
})
export class HeaderContentComponent {
  private store = inject(Store);

  useMobileLayout$: Observable<boolean>;

  constructor() {
    this.useMobileLayout$ = this.store.pipe(select(fromLayoutSelectors.selectUseMobileLayout));
  }
}
